This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div class="profilePage">
    <div class="pageContainer lg:grid-cols-3 md:grid-cols-1">
      <section>
        <UserInfoBlock />
      </section>
      <section>
        <AvatarBlock />
      </section>
      <section>
        <ClassroomsOverviewBlock />
      </section>
    </div>
  </div>
  <QuestionButton :wikiSubjects="this.wikiSubjects" />
</template>

<script lang="ts">
// Import all blocks
import { Options, Vue } from "vue-class-component";
import UserInfoBlock from "@/components/profile/UserInfoBlock.vue";
import AvatarBlock from "@/components/profile/AvatarBlock.vue";
import ClassroomsOverviewBlock from "@/components/profile/ClassroomsOverviewBlock.vue";
import QuestionButton from "@/components/QuestionButton.vue";

@Options({
  data() {
    return {
      wikiSubjects: [],
    };
  },

  mounted() {
    this.updateQuestionButton();
  },

  methods: {
    updateQuestionButton() {
      this.wikiSubjects.push(
        { wikiButton: { name: this.$t("wiki.profile"), item: "profilePage" } },
        { wikiButton: { name: this.$t("wiki.avatar"), item: "avatarPage" } }
      );
    },
  },

  components: {
    UserInfoBlock,
    AvatarBlock,
    ClassroomsOverviewBlock,
    QuestionButton,
  },
})
export default class Profile extends Vue {}
</script>

<style lang="scss">
@import "src/assets/stylesheets/pages/Profile.scss";
</style>
